module.exports = __webpack_public_path__ + "static/2019426:2ace0725733a716000c6/img/hollywood_1x.a3d8416.png";


//////////////////
// WEBPACK FOOTER
// ./app/src/assets/images/home/hollywood_1x.png
// module id = 6/HP
// module chunks = 41